export const playgroundLabels = {
  en: {
    simulation:
      'Test the same conversation behavior as customer chat. Human handoffs here are simulated.',
    handoffNotice:
      'In a live conversation, the AI would hand this to support and stop replying. No real transfer is made in the playground. Reset to start a new test.',
    handoffReply: 'A support specialist can help with the next steps.',
    reset: 'Reset conversation',
    preview: 'Test draft knowledge (administrator preview)',
    draftWarning:
      'Draft preview for review only. These answers may use unapproved knowledge and are not available to customers. Nothing is published by testing here.',
    unpublished:
      'No knowledge is approved yet. Company questions in customer mode will be handed to support. Review and approve the facts, or enable draft preview to test them.',
    published: 'Customer mode uses approved knowledge only.',
    review: 'Review knowledge',
    draftBadge: 'Unpublished draft preview',
    evidence: 'Evidence records',
    failed: 'The assistant could not respond. Try again shortly.',
    unavailable:
      'Could not load knowledge status. Refresh before testing drafts.',
  },
  ar: {
    simulation:
      'اختبر سلوك المحادثة نفسه المستخدم مع العملاء. التحويل إلى الدعم هنا محاكاة فقط.',
    handoffNotice:
      'في محادثة فعلية، سيحوّل الذكاء الاصطناعي المحادثة إلى الدعم ويتوقف عن الرد. لا يحدث تحويل فعلي في ساحة التجربة. أعد ضبط المحادثة لبدء اختبار جديد.',
    handoffReply: 'يمكن لمختص الدعم مساعدتك في الخطوات التالية.',
    reset: 'إعادة ضبط المحادثة',
    preview: 'اختبار المعرفة المسودة (معاينة للمسؤول)',
    draftWarning:
      'هذه معاينة للمراجعة فقط. قد تستخدم الإجابات معرفة غير معتمدة ولا تتاح للعملاء. الاختبار هنا لا ينشر أي معرفة.',
    unpublished:
      'لم تُعتمد المعرفة بعد. أسئلة الشركة في وضع العميل تُحال للدعم. راجع المعلومات واعتمدها، أو فعّل معاينة المسودة لاختبارها.',
    published: 'وضع العميل يستخدم المعرفة المعتمدة فقط.',
    review: 'مراجعة المعرفة',
    draftBadge: 'معاينة مسودة غير منشورة',
    evidence: 'سجلات الأدلة',
    failed: 'تعذّر الحصول على رد من المساعد. حاول مجددًا بعد قليل.',
    unavailable: 'تعذّر تحميل حالة المعرفة. حدّث الصفحة قبل اختبار المسودات.',
  },
};
